module.exports = __webpack_public_path__ + "2acb60f2/img/placeholder.888fcd0b.svg";